/**
 * 領収書発行済み伝票の削除保護ユーティリティ（顧客要望⑥）
 *
 * 店舗設定 `shop.receiptSettings.deleteProtection` に従い、
 * 既に領収書発行済みの伝票（receiptIssued=true）の削除を拒否する。
 *
 * デフォルト: 保護有効。owner/manager は override 可能（設定で許可した場合）。
 */

import type { Shop } from '../types';

export interface ProtectionTarget {
  receiptIssued?: boolean;
}

export interface ProtectionContext {
  shop?: Pick<Shop, 'receiptSettings'> | null;
  userRole?: string;
}

export function isReceiptDeleteProtected(
  target: ProtectionTarget,
  ctx: ProtectionContext
): boolean {
  if (!target.receiptIssued) return false;
  const cfg = ctx.shop?.receiptSettings?.deleteProtection;
  // 未設定 = 保護有効（デフォルト）
  const enabled = cfg?.enabled !== false;
  if (!enabled) return false;
  const overrideRoles = cfg?.allowOverrideRoles ?? [];
  if (ctx.userRole && overrideRoles.includes(ctx.userRole as any)) return false;
  return true;
}

export const RECEIPT_PROTECTION_MESSAGE =
  '領収書発行済みの伝票は削除できません。\n（店舗設定 → レシート → 削除保護 で変更可能）';
